import { render, staticRenderFns } from "./tit-primary.vue?vue&type=template&id=26b7bdb4&scoped=true&"
import script from "./tit-primary.vue?vue&type=script&lang=js&"
export * from "./tit-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b7bdb4",
  null
  
)

export default component.exports